import type { IntlShape } from 'react-intl';
import Heading from '@alltrails/denali/components/Heading';
import type { LanguageRegionCode } from '@alltrails/types/LanguageRegionCode';
import AppStore from '../StoreBadges/AppStore';
import GooglePlay from '../StoreBadges/GooglePlay';
import styles from './styles.module.scss';

type AppForOutdoorsProps = {
  intl: IntlShape;
  languageRegionCode: LanguageRegionCode;
  noReferrerAppLinks?: boolean;
};

const AppForOutdoors = ({ languageRegionCode, noReferrerAppLinks = true, intl }: AppForOutdoorsProps) => (
  <div className={styles.container}>
    <Heading as="h2" className={styles.title} size="300">
      {intl.formatMessage({ defaultMessage: 'An app for the outdoors' })}
    </Heading>
    <div className={styles.appIconsContainer}>
      <AppStore height={35} className={styles.appIcon} languageRegionCode={languageRegionCode} noReferrer={noReferrerAppLinks} intl={intl} />
      <GooglePlay height={35} className={styles.appIcon} languageRegionCode={languageRegionCode} noReferrer={noReferrerAppLinks} intl={intl} />
    </div>
  </div>
);

export default AppForOutdoors;
